import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-float-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "This website is for personal use. Please contact Brian Cho for demo.", -1)),
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isSignedIn)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              onClick: _ctx.googleSignIn,
              color: "primary",
              elevation: "2"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Sign In", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isSignedIn)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              onClick: _ctx.googleSignOut,
              color: "primary",
              elevation: "2"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Sign Out", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}